import xss from 'xss';
export function sanitizeHtml(source) {
    return xss(source, {
        whiteList: {},
        stripIgnoreTag: true,
        stripIgnoreTagBody: ['script'],
    });
}
